import React, { useState, useEffect } from "react";
import { Grid, Button, TextField } from "@material-ui/core";

export default function SearchField(props) {
  const [localSearchString, setLocalSearchString] = useState("");

  useEffect(() => setLocalSearchString(props.searchString), []);

  return (
    <>
      <Grid item>
        <TextField
          id="outlined-error"
          label="Search Remark"
          variant="outlined"
          margin="dense"
          value={localSearchString}
          onChange={(e) => {
            setLocalSearchString(e.target.value);
          }}
        />
      </Grid>
      <Grid item>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            props.setSearchString(localSearchString);
            props.onSearch(localSearchString);
          }}
        >
          Search
        </Button>
      </Grid>
    </>
  );
}
